import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo, useRef, useState } from "react";
import { useQuery } from "@apollo/client";
import { useAmplitude } from "@crehana/analytics";
import { useTranslation } from "@crehana/i18n";
import { Dialog } from "@crehana/ui";
import { isBot } from "@crehana/utils";
import useContactData from "../hooks/useContactData";
var CALL_CENTER_DIALOG_QUERY = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "CallCenterDialogQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "source"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "SourceEnum"
          }
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "popups"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "source"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "source"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isActive"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "contentType"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "type"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "sources"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "popupDetail"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "image"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "imageResponsive"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "imageTablets"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "title"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "description"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "countryCode"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "callToAction"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 306,
    source: {
      body: "query CallCenterDialogQuery($source: [SourceEnum]) {\n  popups(source: $source) {\n    id\n    isActive\n    contentType\n    type\n    name\n    sources\n    popupDetail {\n      id\n      image\n      imageResponsive\n      imageTablets\n      title\n      description\n      countryCode\n      callToAction\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
import CallCenterForm from "./CallCenterForm";
import ThanksView from "./ThanksView";
import { jsx as _jsx } from "react/jsx-runtime";
var Views = /*#__PURE__*/function (Views) {
  Views["FORM"] = "form";
  Views["THANKS_MESSAGE"] = "thanks-message";
  return Views;
}(Views || {});
var CallCenterDialog = function CallCenterDialog(_ref) {
  var _window, _window$navigator;
  var isOpen = _ref.isOpen,
    closeDialog = _ref.closeDialog,
    trackingSource = _ref.trackingSource,
    originUrl = _ref.originUrl,
    dialogSource = _ref.dialogSource,
    source = _ref.source;
  var _source = source ? [source] : undefined;
  var _useTranslation = useTranslation(),
    countryCode = _useTranslation.countryCode;
  var isSearchCrawler = isBot((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent);
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var hasTrackedRender = useRef(false);
  var _useState = useState(Views.FORM),
    _useState2 = _slicedToArray(_useState, 2),
    view = _useState2[0],
    setView = _useState2[1];
  var _useQuery = useQuery(CALL_CENTER_DIALOG_QUERY, {
      variables: {
        source: _source
      }
    }),
    callCenterData = _useQuery.data,
    isCallCenterDataLoading = _useQuery.loading;
  var popupData = useMemo(function () {
    var _callCenterData$popup, _activePopup$popupDet, _activePopup$popupDet2;
    var activePopup = callCenterData === null || callCenterData === void 0 ? void 0 : (_callCenterData$popup = callCenterData.popups) === null || _callCenterData$popup === void 0 ? void 0 : _callCenterData$popup.find(function (popup) {
      return Boolean(popup === null || popup === void 0 ? void 0 : popup.isActive);
    });
    if (!activePopup) {
      return null;
    }
    var allCountriesPopupDetail = activePopup === null || activePopup === void 0 ? void 0 : (_activePopup$popupDet = activePopup.popupDetail) === null || _activePopup$popupDet === void 0 ? void 0 : _activePopup$popupDet.find(function (detail) {
      return !(detail !== null && detail !== void 0 && detail.countryCode);
    });
    if (allCountriesPopupDetail) {
      return allCountriesPopupDetail;
    }
    var countrySpecificPopupDetail = activePopup === null || activePopup === void 0 ? void 0 : (_activePopup$popupDet2 = activePopup.popupDetail) === null || _activePopup$popupDet2 === void 0 ? void 0 : _activePopup$popupDet2.find(function (detail) {
      return (detail === null || detail === void 0 ? void 0 : detail.countryCode) === countryCode;
    });
    return countrySpecificPopupDetail;
  }, [callCenterData === null || callCenterData === void 0 ? void 0 : callCenterData.popups, countryCode]);
  var _useContactData = useContactData(),
    saveContactData = _useContactData.saveContactData;
  if (!hasTrackedRender.current && isOpen) {
    hasTrackedRender.current = true;
    logEvent({
      event: 'Call Center Dialog Render',
      data: {
        dialogSource: source || dialogSource
      }
    });
  }
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      var name, phoneState, MAX_ORIGIN_URL_LENGTH, saveContactDataResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            name = data.name, phoneState = data.phoneNumber;
            if (!(phoneState.phoneNumber.length > 0)) {
              _context.next = 7;
              break;
            }
            MAX_ORIGIN_URL_LENGTH = 200;
            _context.next = 5;
            return saveContactData({
              name: name,
              phoneNumber: phoneState.fullNumber,
              absoluteUrl: originUrl || window.location.href.substring(0, MAX_ORIGIN_URL_LENGTH),
              source: trackingSource
            });
          case 5:
            saveContactDataResponse = _context.sent;
            if (!saveContactDataResponse.success) {
              console.error('Error saving phone number');
            } else {
              logEvent({
                event: 'CallCenterDialog Submit Form',
                data: {
                  dialogSource: source || dialogSource
                }
              });
              setView(Views.THANKS_MESSAGE);
            }
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (isSearchCrawler || isCallCenterDataLoading || !popupData) {
    return null;
  }
  return /*#__PURE__*/_jsx(Dialog, {
    open: isOpen,
    onDismiss: closeDialog,
    size: "l",
    hideCloseBtn: true,
    children: view === Views.THANKS_MESSAGE ? /*#__PURE__*/_jsx(ThanksView, {
      closeDialog: closeDialog
    }) : /*#__PURE__*/_jsx(CallCenterForm, {
      onSubmit: onSubmit,
      closeDialog: closeDialog,
      dialogSource: source || dialogSource,
      popupData: popupData
    })
  });
};
export default CallCenterDialog;